var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs, _script;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThq = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "160 0 300 300",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M311.376 69.6846H393.89V79.0253H311.376V69.6846Z",
    fill: "url(#paint0_linear_1040_55244)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.746 69.6846H393.89L393.889 74.355H225.746V69.6846Z",
    fill: "url(#paint1_linear_1040_55244)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M206.291 85.2542H413.356V89.9246H206.291V85.2542Z",
    fill: "url(#paint2_linear_1040_55244)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M194.613 100.824H425.031V105.494H194.613V100.824Z",
    fill: "url(#paint3_linear_1040_55244)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M183.713 131.963H435.928V136.634H183.713V131.963Z",
    fill: "url(#paint4_linear_1040_55244)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187.606 116.394H432.036V121.064H187.606V116.394Z",
    fill: "url(#paint5_linear_1040_55244)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M291.912 85.2542H413.356L413.349 93.8166H291.912V85.2542Z",
    fill: "url(#paint6_linear_1040_55244)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M280.243 100.824H425.031L425.033 108.608H280.243V100.824Z",
    fill: "url(#paint7_linear_1040_55244)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M273.236 116.394H432.036L432.038 123.399H273.236V116.394Z",
    fill: "url(#paint8_linear_1040_55244)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M269.343 131.963H435.928L435.93 138.19H269.343V131.963Z",
    fill: "url(#paint9_linear_1040_55244)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M182.156 147.533H437.485V152.203H182.156V147.533Z",
    fill: "url(#paint10_linear_1040_55244)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M225.746 225.349H393.889V230.019H225.746V225.349Z",
    fill: "url(#paint11_linear_1040_55244)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M206.291 209.812H413.356V214.482H206.291V209.812Z",
    fill: "url(#paint12_linear_1040_55244)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M194.613 194.242H425.031V198.912H194.613V194.242Z",
    fill: "url(#paint13_linear_1040_55244)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M187.606 178.672H432.036V183.343H187.606V178.672Z",
    fill: "url(#paint14_linear_1040_55244)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M183.713 163.103H435.928V167.773H183.713V163.103Z",
    fill: "url(#paint15_linear_1040_55244)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M183.713 161.53H350.3V167.757H183.713V161.53Z",
    fill: "url(#paint16_linear_1040_55244)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M187.606 176.329H346.408V183.334H187.606V176.329Z",
    fill: "url(#paint17_linear_1040_55244)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M194.613 191.128H339.403V198.912L194.613 198.912V191.128Z",
    fill: "url(#paint18_linear_1040_55244)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M206.291 205.895H327.727V214.457H206.291V205.895Z",
    fill: "url(#paint19_linear_1040_55244)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M225.746 220.694H308.26V230.035H225.746V220.694Z",
    fill: "url(#paint20_linear_1040_55244)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1040_55244",
    x1: 182.156,
    y1: 152.629,
    x2: 437.9,
    y2: 152.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D254"
  })))), _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThq);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/thq.afa06e89a36a43e162fb4a8297afb560.svg";